import type { Feature, Polygon, MultiPolygon, Position } from "geojson";

export enum ZoneType {
	FIELD = 0,
	UNSAFE = 1,
	SLOW = 2,
	PULLIN = 3,
	COLLECTED_FIELD = 4,
	SAMPLE_ZONE = 5,
	VISUAL_ZONE = 6,
}

/** Singleton types — max 1 per job */
export const SINGLETON_ZONE_TYPES: ReadonlySet<ZoneType> = new Set([
	ZoneType.FIELD,
	ZoneType.UNSAFE,
	ZoneType.SLOW,
	ZoneType.PULLIN,
	ZoneType.COLLECTED_FIELD,
]);

export function isSingletonType(type: ZoneType): boolean {
	return SINGLETON_ZONE_TYPES.has(type);
}

export type ZoneId = string;

/** Serializable snapshot of a Zone — used for undo/redo and persistence */
export interface ZoneData {
	id: ZoneId;
	name: string;
	type: ZoneType;
	geometry: Feature<Polygon | MultiPolygon>;
	visible: boolean;
}

export type { Position };
